import {useCallback, useMemo, useState} from 'react';
import React from 'react';
import {DialogTitle, HTMLDialog} from '@priority-software/priority-style-react';
import {useEventListener} from '../../../../../../hooks/useEventListener';

export default function useModal(): [
    JSX.Element | null,
    (title: string, showModal: (onClose: () => void) => JSX.Element) => void
] {
    const [modalContent, setModalContent] = useState<null | {
        closeOnClickOutside: boolean;
        content: JSX.Element;
        title: string;
    }>(null);

    useEventListener('keydown', (e: KeyboardEvent) => {
        if (e.code === 'Esc') {
            e?.stopPropagation();
        }
    });

    const onClose = useCallback(() => {
        setModalContent(null);
    }, []);

    const modal = useMemo(() => {
        if (modalContent === null) return null;

        const {title, content} = modalContent;

        return (
            <HTMLDialog
                title={<DialogTitle title={title} />}
                onClose={onClose}
                isOpen
                content={content}
            />
        );
    }, [modalContent, onClose]);

    const showModal = useCallback(
        (
            title: string,
            // eslint-disable-next-line no-shadow
            getContent: (onClose: () => void) => JSX.Element,
            closeOnClickOutside = false
        ) => {
            setModalContent({
                closeOnClickOutside,
                content: getContent(onClose),
                title
            });
        },
        [onClose]
    );

    return [modal, showModal];
}
